import { render, staticRenderFns } from "./RecentAdvertCarusel.vue?vue&type=template&id=85613104&scoped=true&"
import script from "./RecentAdvertCarusel.vue?vue&type=script&lang=js&"
export * from "./RecentAdvertCarusel.vue?vue&type=script&lang=js&"
import style0 from "./RecentAdvertCarusel.vue?vue&type=style&index=0&id=85613104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85613104",
  null
  
)

export default component.exports